import { GET_CANCELCHARGES, GET_CANCELTRIP } from "resources/actionTypes";


  const initialCleareTripState = {
    loading: false,
    error: null,
  };

  const initialCancelTripChargesState = {
    loading: false,
    error: null,
    cancelCharges: ""
  };

export const cancelTrip = (state = initialCleareTripState, action) => {
  switch (action.type) {
    case GET_CANCELTRIP.GET_CANCELTRIP_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CANCELTRIP.GET_CANCELTRIP_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_CANCELTRIP.GET_CANCELTRIP_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getCancelTripCharges = (state = initialCancelTripChargesState, action) => {
  switch (action.type) {
    case GET_CANCELCHARGES.GET_CANCELCHARGES_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CANCELCHARGES.GET_CANCELCHARGES_SUCCESS:
      return {
        ...state,
        loading: false,
        cancelCharges: action.cancelCharges
      };
    case GET_CANCELCHARGES.GET_CANCELCHARGES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};